import { Type } from 'class-transformer';
import { KeyValueResultDto } from '../../../../../_models/key-value-result-dto';
import { FileInfoDisplayResultDto } from '../../../../../_models/file-info-display-result-dto';
import { UpdatedResultDto } from '../../common/updated-result-dto';
import { APBillItemResultDto } from './ap-bill-item-result-dto';

export class APBillResultDto {
    billId: number;

    @Type(() => Date)
    billDate: Date;

    @Type(() => Date)
    postDate: Date;

    @Type(() => Date)
    dueDate: Date;

    description: string;
    communityId: number;
    managementCompanyId: number;
    vendorId: number;
    vendorName: string;
    amount: number;
    openBalance: number;
    wfJobId: number;
    wfStatus: string;
    billType: string;
    allowReclassify: boolean;
    allowEdit: boolean;
    allowDeleteBill: boolean;
    allowReverseBill: boolean;

    @Type(() => UpdatedResultDto)
    lastUpdate: UpdatedResultDto;

    @Type(() => FileInfoDisplayResultDto)
    supportingDocument: FileInfoDisplayResultDto;

    @Type(() => APBillItemResultDto)
    items: APBillItemResultDto[];

    @Type(() => Date)
    reversedDate: Date;

    entityUsesSubcategory: boolean;

    @Type(() => KeyValueResultDto)
    requiredDimensions: Array<KeyValueResultDto>;
}
